import type { ComparisonValue } from '@epilot/journey-logic-commons/src/types/next'
import { LOGIC_OPERATOR } from '@epilot/journey-logic-commons/src/types/next'
import { z } from 'zod'

import { Operator } from '../operator'

const FactValueSchema = z.unknown().array().optional()

/**
 * TODO: Does it make sense to support contains in string?!
 */
export class Contain extends Operator<unknown[]> {
  constructor() {
    super(LOGIC_OPERATOR.CONTAIN, FactValueSchema)
  }

  evaluate(
    factValue: z.infer<typeof FactValueSchema>,
    comparisonValue: ComparisonValue
  ): boolean {
    // if the factValue is undefined, we assume no matches (therefore false)
    // this is currently needed for multi-select blocks when no options have been selected
    if (!factValue) return false

    if (Array.isArray(comparisonValue)) {
      return comparisonValue.every((v) => factValue.indexOf(v) > -1)
    }

    return factValue.indexOf(comparisonValue) > -1
  }
}
